// extracted by mini-css-extract-plugin
module.exports = {"searchPlace":"blogs_searchPlace__2pqp1"};